import { render } from "./BreadcrumbsMyWorkBlock.vue?vue&type=template&id=a6a1dc80&ts=true"
import script from "./BreadcrumbsMyWorkBlock.vue?vue&type=script&lang=ts"
export * from "./BreadcrumbsMyWorkBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__